var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-btn',{staticClass:"text-danger",attrs:{"variant":"light","pill":""},on:{"click":_vm.resetSearch}},[_vm._v(" "+_vm._s(_vm.$t("Reset"))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }